function initCartRecommendationsSwiper() {
  if (typeof Swiper === 'undefined') {
    setTimeout(initCartRecommendationsSwiper, 500);
    return;
  }
  
  try {
    var cartRecSwiper = new Swiper('#cart-recommendations-slider', {
      slidesPerView: 1,
      spaceBetween: 10,
      slidesPerGroup: 1,
      speed: 300,
      navigation: {
        nextEl: '#cart-recommendations-next',
        prevEl: '#cart-recommendations-prev',
      },
      breakpoints: {
        767: {
          slidesPerView: 1.3,
          spaceBetween: 10
        }
      },
      on: {
        init: function () {
          updateNavigationVisibility(this);
        },
        slideChange: function () {
          updateNavigationVisibility(this);
        }
      }
    });
    
    function updateNavigationVisibility(swiper) {
      const prevButton = document.querySelector('#cart-recommendations-prev');
      const nextButton = document.querySelector('#cart-recommendations-next');
      
      if (prevButton) {
        prevButton.style.display = swiper.isBeginning ? 'none' : 'flex';
      }
      
      if (nextButton) {
        nextButton.style.display = swiper.isEnd ? 'none' : 'flex';
      }
    }
    
    const nextButton = document.querySelector('#cart-recommendations-next');
    const prevButton = document.querySelector('#cart-recommendations-prev');
    
    if (nextButton) {
      nextButton.addEventListener('click', function(e) {
        e.preventDefault();
        cartRecSwiper.slideTo(cartRecSwiper.activeIndex + 0.5);
      });
    }
    
    if (prevButton) {
      prevButton.addEventListener('click', function(e) {
        e.preventDefault();
        console.log("Slide index: " + cartRecSwiper.activeIndex);
        cartRecSwiper.slideTo(cartRecSwiper.activeIndex);
      });
    }
  } catch (e) {
    console.error('Error initializing cart recommendations swiper:', e);
  }
}

function observeProductRecommendations() {
  const recommendationsContainerId = 'cart-recommendations-swiper';
  
  function checkRecommendationsLoaded() {
    const container = document.getElementById(recommendationsContainerId);
    if (container && container.querySelector('.swiper-slide')) {
      setTimeout(function() {
        initCartRecommendationsSwiper();
      }, 50);
      return true;
    }
    return false;
  }
  
  if (checkRecommendationsLoaded()) {
    return;
  }
  const bodyObserver = new MutationObserver(function(mutations) {
    if (checkRecommendationsLoaded()) {
      bodyObserver.disconnect();
    }
  });
  bodyObserver.observe(document.body, { 
    childList: true, 
    subtree: true 
  });
  const checkInterval = setInterval(function() {
    if (checkRecommendationsLoaded()) {
      clearInterval(checkInterval);
    }
  }, 300);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initCartRecommendationsSwiper();
    observeProductRecommendations();
  });
} else {
  initCartRecommendationsSwiper();
  observeProductRecommendations();
}

document.addEventListener('product:added', function() {
  setTimeout(observeProductRecommendations, 100);
});

document.addEventListener('cart:updated', function() {
  setTimeout(observeProductRecommendations, 100);
});

document.addEventListener('click', function(e) {
  if (e.target.matches('button[name="checkout"], button[name="add"], .add-to-cart, .cart-link') || 
      e.target.closest('button[name="checkout"], button[name="add"], .add-to-cart, .cart-link')) {
    setTimeout(observeProductRecommendations, 300);
  }
});

setTimeout(observeProductRecommendations, 1000);
setTimeout(observeProductRecommendations, 2000);